import { HttpClient, HttpParams } from "@angular/common/http";
import { environment } from "src/environments/environment";
import { map } from 'rxjs/operators';
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: 'root'
})
export class AuthTokenService {

    constructor(private http: HttpClient) { }

    /**
     * 
     * @param ac_email 
     * @param ac_modulo 
     * @returns 
     */
    validateAccessUser(
        ac_email: string,
        ac_modulo: string) {
        let params = new HttpParams();
        params = params.append('ac_email', ac_email);
        params = params.append('ac_modulo', ac_modulo);
        return this.http.get(`${environment.api_url_base_validate_access}/basic/validateAccessUser`, { params: params })
            .pipe(map(data => data));
    }
}